export const conversationalPreviewMessageHistory = "/:app_group_id/conversational/preview_message_history";
